export const setAuthRedirectIntent = (intent) => {
  localStorage.setItem("authRedirectIntent", JSON.stringify(intent));
};

export const consumeAuthRedirectIntent = () => {
  const raw = localStorage.getItem("authRedirectIntent");
  if (!raw) return null;

  localStorage.removeItem("authRedirectIntent");
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
